import React from "react";
import PropTypes from "prop-types";

import TableContainer from "./common/TableContainer";
import WindowsEvtsTable, { getRows } from "./WindowsEvtsTable";

/*
Component
*/

const WindowsEvts = ({
  dataSelector,
  fetchData,
  idSelector,
  intervalSelector,
  refresh,
}) => (
  <TableContainer
    dataSelector={dataSelector}
    fetchData={fetchData}
    getRows={getRows}
    idSelector={idSelector}
    intervalSelector={intervalSelector}
    refresh={refresh}
    Table={WindowsEvtsTable}
  />
);

WindowsEvts.propTypes = {
  dataSelector: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  idSelector: PropTypes.func.isRequired,
  intervalSelector: PropTypes.func.isRequired,
  refresh: PropTypes.bool,
};

WindowsEvts.defaultProps = {
  refresh: false,
};

export default WindowsEvts;
